import { makeStyles } from '@mui/styles'

export default makeStyles({
   pin: {
      maxWidth: 30
   },
   pinCar: {
      maxWidth: 45
   },
})
